import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { memo } from "react";

interface MealAllergensTagsProps {
  allergens?: string[];
}

export const MealAllergensTags = memo(function MealAllergensTags({
  allergens,
}: MealAllergensTagsProps) {
  if (!allergens || allergens.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-4 mb-2">
      <h6 className={cn(textVariants.title3, "font-semibold text-center")}>Allergens:</h6>
      <div className="flex flex-wrap items-center justify-center gap-2">
        {allergens.map((allergen, index) => (
          <span
            key={index}
            className={cn(textVariants.footnote, "rounded-full bg-gray-100 px-4 py-2 capitalize")}
          >
            {allergen}
          </span>
        ))}
      </div>
    </div>
  );
});
